export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '亲亲漫画网的漫画都是免费的吗？',
    answer: '是的！亲亲漫画网上所有的漫画内容都是完全免费的。我们致力于为漫画爱好者提供最优质的下拉式阅读体验，无需付费即可畅享海量日漫、韩漫和国漫资源。我们会持续更新最新话，让您第一时间追更心仪的漫画。',
  },
  {
    question: '什么是下拉式漫画阅读？',
    answer: '下拉式漫画阅读是一种创新的阅读方式，您只需要向下滑动页面，漫画内容就会像瀑布一样连续呈现，无需点击翻页按钮。这种方式模拟了卷轴阅读的体验，让您沉浸在流畅的阅读中，特别适合条漫和网漫的阅读。相比传统翻页，下拉式阅读更加自然、连贯，一次加载整话内容，让阅读体验更加丝滑流畅。',
  },
  {
    question: '亲亲漫画网支持哪些类型的漫画？',
    answer: '我们收录了丰富的漫画类型，包括但不限于：日漫、韩漫、国漫三大类，涵盖了热血、恋爱、搞笑、奇幻、悬疑、校园、战斗、电竞、运动等多种题材。无论你喜欢什么风格的漫画，都能在亲亲漫画网找到心仪的作品。',
  },
  {
    question: '漫画多久更新一次？',
    answer: '更新频率取决于漫画本身的连载周期。热门连载漫画通常每周更新一次，我们会与官方保持同步，在第一时间上线最新章节。您可以收藏喜欢的漫画，追更提醒会在更新后通过页面通知您。完结作品可以直接阅读全部章节，无需等待！',
  },
  {
    question: '在手机上能看漫画吗？',
    answer: '当然可以！亲亲漫画网采用响应式设计，完美适配手机、平板和电脑等各种设备。在手机端，下拉式阅读体验更加出色，配合触摸滑动，让您随时随地享受漫画的乐趣。无论是在通勤路上还是睡前时光，都能轻松追漫。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过多种方式找到喜欢的漫画：在首页的搜索框中直接输入漫画名称搜索；通过顶部的分类导航按类型浏览；查看首页的"热门推荐"和"最新上架"板块发现热门和新作；也可以按标签（热血、恋爱、奇幻等）筛选感兴趣的漫画。',
  },
];